import React from "react"
import { StyleSheetManager } from "styled-components"

import { linkedCSS, styles as frameStyles } from "../../live-code-styles"
import FrameComponent, { FrameContextConsumer } from "react-frame-component"
import Measure from "react-measure"

const initialHead = (
  <>
    {linkedCSS.map(l => {
      return (
        <link key={`css-link-${l}`} type="text/css" rel="stylesheet" href={l} />
      )
    })}
    <style>${frameStyles}</style>
  </>
)

function Frame({ children }) {
  const [height, setHeight] = React.useState("auto")
  return (
    <FrameComponent
      head={initialHead}
      style={{ width: "100%", border: 0, height }}
    >
      <FrameContextConsumer>
        {props => {
          const { document, window } = props
          // By default, styled-components injects styles in the head of the page.
          // However, styles from the page's head don't apply inside iframes.
          // We're using StyleSheetManager to make styled-components inject styles
          // into the head of the iframe instead.

          // temporary solution
          // get all the linked styles from parent document
          const linked = [
            ...window.parent.document.querySelectorAll(
              'link[rel="stylesheet"]'
            ),
          ]
          linked.forEach(l => {
            document.head.appendChild(l.cloneNode(true))
          })

          const styles = [...window.parent.document.querySelectorAll("style")]
          styles.forEach(s => {
            document.head.appendChild(s.cloneNode(true))
          })
          return (
            <>
              <style>{`/* styles here */`}</style>
              <Measure
                // iframes don't adjust to the height of their content by default.
                // We're using Measure to calculate the size of the content
                // and adjust the iframe's height dynamically.
                bounds={true}
                onResize={rect => setHeight(rect.bounds.height)}
              >
                {({ measureRef }) => <div ref={measureRef}>{children}</div>}
              </Measure>
            </>
          )
        }}
      </FrameContextConsumer>
    </FrameComponent>
  )
}

export default Frame
